import { render } from "./IconBedTimeDown.vue?vue&type=template&id=624e6b7f"
import script from "./IconBedTimeDown.vue?vue&type=script&lang=js"
export * from "./IconBedTimeDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__